import { createSelector } from 'reselect';
import { deliverySelector } from 'redux/modules/delivery';

export const getDeliveryType = createSelector(
  deliverySelector,
  delivery => delivery.type,
);
